(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


'use strict';
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.getInitialState();
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        // eslint-disable-next-line no-console
        this.state = initialState;
        this.score = 0;
        this.status = 'idle';
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                this.moveInline('left');
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                this.moveInline('right');
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.moveBlock('up');
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.moveBlock('down');
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.score = 0;
                this.status = 'playing';
                this.addRandomSell();
                this.addRandomSell();
            }
        },
        {
            // Add your own methods here
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.status = 'idle';
                this.score = 0;
                this.state = this.getInitialState();
            }
        },
        {
            // Add your own methods here
            key: "moveBlock",
            value: function moveBlock(direction) {
                var _this = this;
                if (this.getStatus() === 'playing') {
                    var isMove = false;
                    this.state.forEach(function(row, rowIndex) {
                        var column = [];
                        row.forEach(function(_, cellIndex) {
                            column.push(_this.state[cellIndex][rowIndex]);
                        });
                        var notEmptyCells = _this.getNotEmptyCells(column, direction);
                        notEmptyCells = _this.mergeCells(notEmptyCells, direction);
                        for(var i = 0; i < 4; i++){
                            _this.state[i][rowIndex] = notEmptyCells[i] || 0;
                            if (_this.state[i][rowIndex] !== column[i]) isMove = true;
                        }
                    });
                    if (isMove) {
                        this.addRandomSell();
                        this.checkWinLose();
                    }
                }
            }
        },
        {
            key: "moveInline",
            value: function moveInline(direction) {
                var _this = this;
                if (this.getStatus() === 'playing') {
                    var isMove;
                    this.state.forEach(function(row) {
                        var oldRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                        var notEmptyCells = _this.getNotEmptyCells(row, direction);
                        notEmptyCells = _this.mergeCells(notEmptyCells, direction);
                        row.forEach(function(_, i) {
                            row[i] = notEmptyCells[i] || 0;
                        });
                        if (!oldRow.every(function(cell, index) {
                            return cell === row[index];
                        })) isMove = true;
                    });
                    if (isMove) {
                        this.addRandomSell();
                        this.checkWinLose();
                    }
                }
            }
        },
        {
            key: "getInitialState",
            value: function getInitialState() {
                return new Array(4).fill(0).map(function() {
                    return new Array(4).fill(0);
                });
            }
        },
        {
            key: "addRandomSell",
            value: function addRandomSell() {
                var freeIndex = [];
                for(var row = 0; row < 4; row++){
                    for(var col = 0; col < 4; col++)if (this.state[row][col] === 0) freeIndex.push([
                        row,
                        col
                    ]);
                }
                var getRandIndex = Math.floor(Math.random() * freeIndex.length);
                var getNum = Math.random() < 0.9 ? 2 : 4;
                var _freeIndex_getRandIndex = (0, $efec029548ccee7f$export$71511d61b312f219)(freeIndex[getRandIndex], 2), newRow = _freeIndex_getRandIndex[0], newCol = _freeIndex_getRandIndex[1];
                this.state[newRow][newCol] = getNum;
            }
        },
        {
            key: "getNotEmptyCells",
            value: function getNotEmptyCells(position, direction) {
                var notEmptyCells = position.filter(function(cell) {
                    return cell > 0;
                });
                if (direction === 'right' || direction === 'down') while(notEmptyCells.length < 4)notEmptyCells.unshift(0);
                if (direction === 'left' || direction === 'up') while(notEmptyCells.length < 4)notEmptyCells.push(0);
                return notEmptyCells;
            }
        },
        {
            key: "mergeCells",
            value: function mergeCells(cells, direction) {
                for(var i = 0; i < cells.length - 1; i++){
                    var valueOne = cells[i];
                    var valueTwo = cells[i + 1];
                    if (valueOne === valueTwo && valueOne > 0) {
                        this.score += valueOne + valueTwo;
                        cells[i] = valueOne + valueTwo;
                        cells.splice(i + 1, 1);
                    }
                }
                if (direction === 'right' || direction === 'down') return this.getNotEmptyCells(cells, direction);
                return cells;
            }
        },
        {
            key: "hasMove",
            value: function hasMove() {
                for(var row = 0; row < 4; row++)for(var col = 0; col < 4; col++){
                    var current = this.state[row][col];
                    if (current === 0) return true;
                    if ((row < 3 ? this.state[row + 1][col] : 0) === current) return true;
                    if ((col < 3 ? this.state[row][col + 1] : 0) === current) return true;
                }
                return false;
            }
        },
        {
            key: "checkWinLose",
            value: function checkWinLose() {
                if (this.state.some(function(row) {
                    return row.includes(2048);
                })) this.status = 'win';
                if (!this.hasMove()) this.status = 'lose';
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$buttonStart = document.querySelector(".button.start");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$gameScore = document.querySelector(".game-score");
var $197cd56b15c33885$var$gameScoreAdd = document.querySelector(".game-score-add");
var $197cd56b15c33885$var$timerId;
function $197cd56b15c33885$var$updatedTable() {
    var state = $197cd56b15c33885$var$game.getState();
    var rows = document.querySelectorAll(".field-row");
    var currentScore = +$197cd56b15c33885$var$gameScore.textContent || 0;
    var newScore = $197cd56b15c33885$var$game.getScore();
    var scoreDiff = newScore - currentScore;
    if (scoreDiff > 0 && $197cd56b15c33885$var$game.getStatus() !== "idle") {
        $197cd56b15c33885$var$gameScoreAdd.classList.remove("game-score-add--move");
        $197cd56b15c33885$var$gameScoreAdd.offsetWidth;
        clearTimeout($197cd56b15c33885$var$timerId);
        $197cd56b15c33885$var$gameScoreAdd.textContent = "+".concat(scoreDiff);
        $197cd56b15c33885$var$gameScoreAdd.classList.add("game-score-add--move");
        $197cd56b15c33885$var$timerId = setTimeout(function() {
            $197cd56b15c33885$var$gameScoreAdd.classList.remove("game-score-add--move");
        }, 500);
    }
    $197cd56b15c33885$var$gameScore.textContent = newScore;
    state.forEach(function(row, iRow) {
        row.forEach(function(valueCell, iCell) {
            var cell = rows[iRow].children[iCell];
            cell.className = "field-cell";
            cell.textContent = "";
            if (valueCell > 0) {
                cell.textContent = valueCell;
                cell.classList.add("field-cell--".concat(valueCell));
            }
        });
    });
    if ($197cd56b15c33885$var$game.getStatus() === "win") $197cd56b15c33885$var$messageWin.classList.remove("hidden");
    else if ($197cd56b15c33885$var$game.getStatus() === "lose") $197cd56b15c33885$var$messageLose.classList.remove("hidden");
}
$197cd56b15c33885$var$buttonStart.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$buttonStart.classList.remove("start");
        $197cd56b15c33885$var$buttonStart.classList.add("restart");
        $197cd56b15c33885$var$buttonStart.textContent = "Restart";
        $197cd56b15c33885$var$messageStart.classList.add("hidden");
    } else {
        $197cd56b15c33885$var$buttonStart.classList.remove("restart");
        $197cd56b15c33885$var$buttonStart.classList.add("start");
        $197cd56b15c33885$var$buttonStart.textContent = "Start";
        $197cd56b15c33885$var$messageStart.classList.remove("hidden");
        $197cd56b15c33885$var$messageLose.classList.add("hidden");
        $197cd56b15c33885$var$messageWin.classList.add("hidden");
        $197cd56b15c33885$var$game.restart();
    }
    $197cd56b15c33885$var$updatedTable();
});
document.addEventListener("keydown", function(e) {
    switch(e.key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
    }
    $197cd56b15c33885$var$updatedTable();
});

})();
//# sourceMappingURL=2048.4d66c14e.js.map
